<div class="comment-form-wrapper-frame" *ngIf="displayCommentForm" (click)="hideForm()">
    
    <div class="comment-form-wrapper">
      <div class="close-wrapper" (click)="displayCommentFormChange(false)">
        <div>X</div>
      </div>
          <div class="comment-form" (click)="preventDefault()">
  
            <div class="comment-form-logo"></div>
            <div class="send-new-comment-title">שלח תגובה חדשה</div>
  
            <div class="star-wrapper">
              <span *ngFor="let star of starsArray; let index = index" (click)="setStar(index)">
                <span class="empty-star" *ngIf="index>=comment.Stars">
                  <fa-icon [icon]="['far', 'star']"></fa-icon>
                </span>
                <span class="full-star" *ngIf="index<comment.Stars">
                  <fa-icon [icon]="['fas', 'star']"></fa-icon>
                </span>
              </span>
            </div>
  
            <div class="form-group col-md-12">
  
  
              <label for="user-name" class="title-label">שם</label>
  
              <input type="text" class="form-control" id="user-name" [(ngModel)]="comment.Name" />
              <div class="form-control-label alert-danger" *ngIf="fieldHasError[0]">יש למלא שם</div>
  
            </div>
            <div class="form-group col-md-12">
  
  
              <label for="user-name" class="title-label">אימייל (הכתובת לא תהיה חשופה לגולשים)</label>
  
              <input type="text" class="form-control" id="user-email" (change)="checkEmail()" [(ngModel)]="comment.UserEmail" />
              <div class="form-control-label alert-danger" *ngIf="fieldHasError[1]">
                יש למלא כתובת אימייל
              </div>
  
            </div>
            <div class="form-group col-md-12">
              <label for="comment" class="title-label">תוכן</label>
              <textarea type="text" rows="5" class="form-control" id="comment" [(ngModel)]="comment.CommentMsg">
                  </textarea>
            </div>
            <div class="form-group col-md-12" *ngIf="displayGoogleRobot">
              <re-captcha class="recaptcha" (resolved)="resolved($event)" siteKey="{{recaptchaKey}}"></re-captcha>
              <div class="form-control-label alert-danger" *ngIf="fieldHasError[2]">יש לסמן ב-v את "אני לא רובוט"</div>
            </div>
            <div class="col-sm-12">
  
              <div class="pay-btn" (click)="sendComment()">שלח</div>
            </div>
            <div class="col-sm-12 pay-attention">שימו לב, רק משתמשים שרכשו כבר פעם אחת באתר יכולים להגיב בחלק זה</div>
          </div>
    </div>
    
    <div class="msg-wrapper" *ngIf="displayError || displaySuccess || displayEmailError">
        <div *ngIf="displayError" class="faild-msg">
          <span class="close-x-msg" (click)="displayError=false;">x</span>
          אופס! התרחשה תקלה. לא ניתן לשלוח כרגע את ההודעה
        </div>
        <div *ngIf="displayEmailError" class="faild-msg">
          <span class="close-x-msg" (click)="displayEmailError=false;">x</span>
          כתובת אימייל לא קיימת במערכת. לא ניתן להגיב עם כתובת זו.
        </div>
        <div *ngIf="displaySuccess" class="success-msg">
          <span class="close-x-msg" (click)="displaySuccess=false;">x</span>
          התגובה שלך נשלחה בהצלחה
        </div>
      </div>
      
  </div>
